let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1PZhB")).then(() => parcelRequire('7Y7aa'));